/**
 * Il file contiene due funzioni che ritornano un indice di
 * sogmilianza tra le due stringhe proposte in input
 * Le funzioni usano algoritmi differenti e compareTwoStrings
 * è leggermente più performante rispetto a similarity,
 * pertanto per liste enormi di risultate sarebbe più indicato,
 * altrimenti bisogna provare qualche algoritmo funziona di
 * più con lo specifico caso di utilizzo
 */

/**
 * sarebbe l'algoritmo di soresen-dice ma con finestra fissa. Rimuove tutti gli spazi prima di comparare (???)
 * @param {string} first 
 * @param {string} second 
 * @returns 
 */
export function compareTwoStrings(first, second) {
    first = first.replace(/\s+/g, '')
    second = second.replace(/\s+/g, '')

    if (first === second) return 1; // identical or empty
    if (first.length < 2 || second.length < 2) return 0; // if either is a 0-letter or 1-letter string

    let firstBigrams = new Map();
    for (let i = 0; i < first.length - 1; i++) {
        const bigram = first.substring(i, i + 2);
        const count = firstBigrams.has(bigram)
            ? firstBigrams.get(bigram) + 1
            : 1;

        firstBigrams.set(bigram, count);
    }

    let intersectionSize = 0;
    for (let i = 0; i < second.length - 1; i++) {
        const bigram = second.substring(i, i + 2);
        const count = firstBigrams.has(bigram)
            ? firstBigrams.get(bigram)
            : 0;

        if (count > 0) {
            firstBigrams.set(bigram, count - 1);
            intersectionSize++;
        }
    }

    return (2.0 * intersectionSize) / (first.length + second.length - 2);
}

export function similarity(s1, s2) {
    let longer = s1;
    let shorter = s2;

    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }

    let longerLength = longer.length;

    if (longerLength === 0) {
        return 1.0;
    }

    return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

function editDistance(s1, s2) {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    const costs = [];

    for (let i = 0; i <= s1.length; ++i) {

        let lastValue = i;

        for (let j = 0; j <= s2.length; ++j) {
            if (i === 0) {
                costs[j] = j;
                continue;
            }

            if (j > 0) {
                let newValue = costs[j - 1];

                if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
                    newValue = Math.min(
                        Math.min(newValue, lastValue),
                        costs[j]
                    ) + 1;
                }

                costs[j - 1] = lastValue;
                lastValue = newValue;
            }
        }

        if (i > 0) {
            costs[s2.length] = lastValue;
        }
    }

    return costs[s2.length];
}

export const diceSimilarity = (str1, str2, substringLength = 2, caseSensitive = false) => {
	if (!caseSensitive) {
		str1 = str1.toLowerCase();
		str2 = str2.toLowerCase();
	}

	if (str1.length < substringLength || str2.length < substringLength)
		return 0;

	const map = new Map();
	for (let i = 0; i < str1.length - (substringLength - 1); i++) {
		const substr1 = str1.substr(i, substringLength);
		map.set(substr1, map.has(substr1) ? map.get(substr1) + 1 : 1);
	}

	let match = 0;
	for (let j = 0; j < str2.length - (substringLength - 1); j++) {
		const substr2 = str2.substr(j, substringLength);
		const count = map.has(substr2) ? map.get(substr2) : 0;
		if (count > 0) {
			map.set(substr2, count - 1);
			match++;
		}
	}

	return (match * 2) / (str1.length + str2.length - ((substringLength - 1) * 2));
};


//> Eof